import PropTypes from 'prop-types'
import React, { useEffect, useRef } from 'react'
import { calibrateOnResize, calibrateOnScroll } from 'lib/utils/scroll'

const DesktopWrapper = ({ children, className }) => {
  const wrapperRef = useRef()

  useEffect(() => {
    if (!wrapperRef?.current) {
      /* istanbul ignore next */
      return () => null
    }

    const defaultTop = 80
    const onResizeFn = () => calibrateOnResize(wrapperRef.current, defaultTop)
    const onScrollFn = () => calibrateOnScroll(wrapperRef.current, defaultTop)

    // Can implement debounce if needed (delay + transition)
    window.addEventListener('resize', onResizeFn)
    window.addEventListener('scroll', onScrollFn)

    return () => {
      window.removeEventListener('resize', onResizeFn)
      window.removeEventListener('scroll', onScrollFn)
    }
  }, [wrapperRef])

  return (
    <div className={className} ref={wrapperRef}>
      {children}
    </div>
  )
}

DesktopWrapper.defaultProps = { className: '' }

DesktopWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}

export default DesktopWrapper
